import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import router from "@/router";
import { BASE_URL } from "./variables"

var host = window.location.hostname;
let baseUrl = BASE_URL;

if (host === "gdth.cliker.com.mx" || host === "www.gdth.cliker.com.mx") {
  baseUrl = "https://apigdth.cliker.com.mx/api/";
} else if (
  host === "mid20dev.pbmg.com.mx" ||
  host === "www.mid20dev.pbmg.com.mx"
) {
  baseUrl = "https://apidevmid19.pbmg.com.mx/api/";
}

axios.defaults.baseURL = baseUrl;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
var ruta = window.location.href.split("#/");

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(e) {
    if (e.response.statusText == "Unauthorized" && ruta[1] != "login") {
      router.push("/");
    } else {
      return Promise.reject(e);
    }
  }
);

var token = localStorage.getItem("tokenPB");
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

Vue.use(VueAxios, axios);
